import type { Metadata } from "next";
import { LoginForm } from "./_form";

export const metadata: Metadata = {
  title: "Đăng nhập",
  robots: { index: false, follow: false },
};

export default async function LoginPage({
  searchParams,
}: {
  searchParams: Promise<{ from?: string }>;
}) {
  const sp = await searchParams;
  return (
    <div className="max-w-container mx-auto px-4 py-12 lg:py-20">
      <div className="max-w-sm mx-auto">
        <h1 className="font-display text-2xl font-bold text-ink-primary mb-1">Đăng nhập</h1>
        <p className="text-sm text-ink-muted mb-6">
          Truy cập admin để quản lý nội dung Finzone.
        </p>
        <LoginForm from={sp.from ?? "/admin"} />
      </div>
    </div>
  );
}
